import AData from "../tools/AData";
import ABuilder from "../tools/ABuilder";

export default class Place {

    constructor(aData) {
        this._data = new AData(aData);
    }

    render() {
        let data = this._data;

        if (data.get('uid')) {
            /*
             * Image
             */
            let image = ABuilder('div', {'class': 'info-img-container'}, [
                ABuilder('div', {'class': 'info-img', 'style': 'background-image:url(' + data.get('image') + ')'})
            ]);

            let previousPlace = ABuilder('div', {'class': 'previous-place snookfun-icon snookfun-icon-chevron-left hidden'});
            let nextPlace = ABuilder('div', {'class': 'next-place snookfun-icon snookfun-icon-chevron-right hidden'});

            /*
             * Header
             */
            let header = ABuilder('div', {'class': 'info-header'}, [
                image,
                previousPlace,
                nextPlace,
            ]);


            /*
             * Close button
             */
            let closeButton = ABuilder('div', {'class': 'info-close snookfun-icon snookfun-icon-close'});

            /*
             * Name
             */
            let name = ABuilder('h4', {'class': 'info-title'}, [
                data.get('title')
            ]);

            /*
             * address
             */
            let address = ABuilder('p', {'class': 'light'}, [
                data.get('address1'),
                data.get('address2') ? ABuilder('br') : '',
                data.get('address2') ? data.get('address2') : ''
            ]);

            /*

             */


            /*
             * Telephone
             */
            let phone = '';
            if (data.get('tel')) {
                phone =
                    ABuilder('a', {
                        'class': 'contact-item phone',
                        'href': 'tel://' + data.get('tel').replace(/ |\//gi, '-').replace(/-{2,}/gi, '-')
                    }, [
                        data.get('tel')
                    ]);
            }

            /*
             * email
             */
            let email = '';

            if (data.get('email')) {
                email = ABuilder('a', {
                    'class': 'contact-item mail',
                    'href': 'mailto:' + data.get('email')
                }, [
                    data.get('email')
                ]);
            }

            /*
             * website
             */
            let website = '';

            if (data.get('website_url')) {
                website = ABuilder('a', {
                    'class': 'contact-item site',
                    'href': 'http://' + data.get('website_url').replace(' _blank', ''),
                    'target': '_blank'
                }, [
                    data.get('website_url').replace(' _blank', '')
                ]);
            }

            /*
             * Contact
             */
            let contact = '';

            if (phone || email || website) {
                contact = ABuilder('p', {'class': 'info-contact light'}, [
                    phone,
                    email,
                    website
                ]);
            }


            let abstract = '';

            if (data.get('abstract')) {
                abstract = ABuilder('p', {'class': 'light'}, [
                    data.get('abstract')
                ]);
            }

            let openingHours = '';
            if (data.get('business_hours')) {
                openingHours = ABuilder('div', {'class': 'info-horaire'}, [
                    ABuilder('h5', {}, [
                        "Horaire d'ouverture"
                    ]),
                    ABuilder('p', {'class': 'light'}, [
                        data.get('business_hours').replace(/\n|\r|\r\n/gi, '<br/>').replace(/(<br\/>){2,}/gi, '<br/>')
                    ])
                ]);
            }

            let placePage = '';
            if (data.get('internalUrl')) {
                placePage = ABuilder('a', {'href': data.get('internalUrl')}, [
                    ABuilder('div', {'class': 'externalLink'}, [
                        'Plus d\'informations'
                    ])
                ]);
            }


            let mainInfos = ABuilder('div', {'class': 'info'}, [
                name,
                address,
                contact,
                abstract,
                openingHours,
                placePage
            ]);

            // console.log(mainInfos);


            $('.content-area')
                .html('')
                .append(header)
                .append(closeButton)
                .append(mainInfos)
                .attr('data-uid', data.get('uid'));

            this.attachEvents();
        } else {
            let placeDetailsContainer = $('.map-info-block');
            let loader = placeDetailsContainer.find('.loader-area');
            let details = placeDetailsContainer.find('.content-area');

            loader.addClass('hidden');
            details.addClass('hidden');
        }
    }

    attachEvents() {

    }

}